import { useState, useEffect } from 'react'
import { countryList } from '../../data/countries'
import { useCountryContext } from '../../hooks/useCountryContext'

export default function CountryList() {
	const [disableBtn, setDisableBtn] = useState(true)
	const [selectedCountry, setSelectedCountry] = useState('')
	const [error, setError] = useState(null)
	const { dispatch, countries } = useCountryContext()
	const [bannedCountryList, setBannedCountryList] = useState(
		countries ? countries : []
	)

	const handleSelectedCountry = e => {
		setError(null)
		setSelectedCountry(e.target.value)
	}

	const handleCountryBan = e => {
		e.preventDefault()
		if (bannedCountryList.includes(selectedCountry)) {
			setError('You already banned ' + selectedCountry)
			return
		}
		setBannedCountryList(prev => [...prev, selectedCountry])
	}

	const handleBanRemoval = countryId => {
		setBannedCountryList(
			bannedCountryList.filter(country => country !== countryId)
		)
	}

	useEffect(() => {
		// without this use effect the dispatch would  run before the state is properly set
		// the use effect ensures that all state values are captured and sent the localStorage
		if (countries ? countries : bannedCountryList) {
			dispatch({
				type: 'ADD_COUNTRY',
				payload: [...bannedCountryList],
			})
			dispatch({
				type: 'REMOVE_COUNTRY',
				payload: [...bannedCountryList],
			})
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [bannedCountryList, dispatch])

	useEffect(() => {
		//this is to ensure that you can not set '--Select--' as a country
		//by disabling the submit button
		selectedCountry === '--Select--' || !selectedCountry
			? setDisableBtn(true)
			: setDisableBtn(false)
	}, [selectedCountry])

	return (
		<div className='flex'>
			<div className='flex items-center'>
				<div className='flex'>
					<div className='m-2 bg-white p-5 rounded-md shadow-md'>
						<p>Manage Authorised Countries</p>
						<p className='text-xs text-gray-500 my-2'>
							Available for businesses in 110 countries.
						</p>
						<select
							onChange={handleSelectedCountry}
							required
							className='textfield'>
							{countryList.map(country => (
								<option key={country} value={country}>
									{country}
								</option>
							))}
						</select>
						{error && <p className='text-xs text-red-500'>{error}</p>}
						<button
							disabled={disableBtn}
							onClick={handleCountryBan}
							className={`submitBtn ${disableBtn && 'bg-gray-200'}`}>
							Add to Ban List
						</button>
					</div>
					<div className='m-2 relative justify-between bg-white p-5 rounded-md shadow-md'>
						<div>
							<p>Banned Countries</p>
							<p className='text-xs text-gray-500 my-2'>
								Below are countries we do not support
							</p>
							<div className='w-60 border p-2 mb-2'>
								<p>
									{!countries?.length ? 'No' : countries?.length} banned
									countries listed
								</p>
							</div>
							{countries &&
								countries.map(country => (
									<div className='textfield flex justify-between' key={country}>
										<p>{country}</p>
										<p
											onClick={() => handleBanRemoval(country)}
											className='text-xs text-white py-1 px-2 bg-red-500 rounded-sm cursor-pointer hover:bg-red-400'>
											remove ban
										</p>
									</div>
								))}
						</div>
						<p className='pt-5 text-gray-500 my-2 text-xs'>
							{'< prev'}
							<span className='px-2 mx-1 rounded-sm text-white bg-gray-400'>
								1
							</span>
							{'next >'}
						</p>
					</div>
				</div>
			</div>
		</div>
	)
}
